import axios from "axios";
import { apiCreateAssociationCreate, apiCreateNetworkRequestAssociation, apiVulnerabilitiesCreate } from "../../sdk";
import { CommandConnection, IOBlock, NetworkRequestConnection } from "../../sdkStructs";

export async function createAssociationById(token: string, vulnId: number, selectedIOBlocks: IOBlock[]) {
  try {
    selectedIOBlocks.forEach((element) => {
      if (element.type === "command") {
        const association: CommandConnection = { vulnerability_id: vulnId, command_id: element.id };
        apiCreateAssociationCreate(token, association);
      } else {
        const association: NetworkRequestConnection = {
          vulnerability_id: vulnId,
          network_request_id: element.id,
        };
        apiCreateNetworkRequestAssociation(token, association);
      }
    });
  } catch (error: unknown) {
    if (!axios.isAxiosError(error)) {
      return;
    }
    if (error.response?.statusText == "Forbidden") {
      return;
    }

    console.log("ERROR CREATING ASSOCIATION:", error.response);
  }
}

export async function addVuln(token: string, selectedIOBlocks: IOBlock[], name: string, pentestId: number) {
  try {
    console.log("Pentest id", pentestId);
    const response = await apiVulnerabilitiesCreate(token, { Name: name, Pentest: pentestId });
    createAssociationById(token, response.data.ID, selectedIOBlocks);
  } catch (error) {
    if (!axios.isAxiosError(error)) {
      alert(error);
      return;
    }
    console.log("ERROR ADDING VULN:", error.response);
  }
}
